import { useState } from 'react';
import { getNukeLegendDescription } from '../../shared/nukeLegend';

export function NukeHighlightChip({ label, tipId, className = '' }) {
    const description = getNukeLegendDescription(label);
    const [open, setOpen] = useState(false);

    if (!description) {
        return (
            <li className={['gs-nuke-unit__highlight', className].filter(Boolean).join(' ')}>
                {label}
            </li>
        );
    }

    const chipClass = [
        'gs-nuke-unit__highlight',
        'gs-nuke-unit__highlight--has-tip',
        className,
        open ? 'is-tip-open' : '',
    ].filter(Boolean).join(' ');

    return (
        <li
            className={chipClass}
            tabIndex={0}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                setOpen((current) => !current);
            }}
            aria-describedby={open ? tipId : undefined}
        >
            {label}
            <span id={tipId} className="gs-nuke-highlight-tip" role="tooltip">
                {description}
            </span>
        </li>
    );
}
